/*global gData:false, __webpack_public_path__:true */
const CDN = (gData && gData.uiCdn) ? gData.uiCdn + "/" : "https://d2sgc57sw7l730.cloudfront.net/";
__webpack_public_path__ = CDN + __webpack_public_path__ + "/";
